export default {"src":"/_next/static/media/checkmark-black.560afa05.svg","height":11,"width":14,"blurWidth":0,"blurHeight":0};